import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Container = styled.div`
  ${({ theme }) => css`
    align-items: flex-start;
    background-color: ${theme.v2.colors.neutral.highPure};
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 32px 24px;
  `}
`;

export const TitleRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

export const TitleSelectWrapper = styled.div`
  max-width: 241px;
  width: 100%;
`;

export const Title = styled.h2`
  ${({ theme }) => css`
    align-items: center;
    color:${theme.v2.colors.brand.primaryExtraDark};
    display: flex;
    flex-direction: row;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.sm};
    font-weight: ${theme.v2.font.weights.medium};
    gap: 16px;
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 0 0 24px 0;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      margin: 0;

      svg {
        display: none;
      }
    }
  `}
`;

export const VisitsWrapper = styled(Wrapper)`
  margin-bottom: 64px;
  position: relative;
  width: 100%;
`;

export const CardsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
`;

export const Card = styled.div`
  ${({ theme }) => css`
    border: 1px solid ${theme.v2.colors.neutral.highMedium};
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    font-family: ${theme.v2.font.family.primary};
    gap: 8px;
    padding: 24px;
    max-width: 272px;
    width: 100%;

    p {
      margin: 0;
    }

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      max-width: 100%;
    }
  `};
`;

export const CardTitle = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
  `};
`;

export const CardSubtitle = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-size: ${theme.v2.font.sizes.xxs};
  `};
`;

export const CardInfo = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-size: ${theme.v2.font.sizes.md};
    font-weight: ${theme.v2.font.weights.medium};
  `};
`;

export const ChartContainer = styled.div`
  width: 100%;
  height: 400px
`;

export const MapWrapper = styled.div`
  ${({ theme }) => css`
    margin: 24px 0px 0px 0px;
    width: 100%;
    @media (max-width: ${theme.v2.breakpoints.md}) {
      display: none;
    }
  `}
`;

export const ListWrapper = styled.ul`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    min-width: 100%;
    padding: 0px 24px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      padding: 0px;
    }
  `}
`;

export const ListItem = styled.li`
  ${({ theme }) => css`
    align-items: center;
    border-bottom: 1px solid ${theme.v2.colors.neutral.highMedium};
    color: ${theme.v2.colors.neutral.lowPure};
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    justify-content: space-between;
    line-height: ${theme.v2.font.lineHeight.list};
    list-style-type: none;
    padding: 32px 0px;

    &:first-child{
      padding: 24px 0px 32px;
    }
  `}
`;

export const ListTitle = styled(ListItem)`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.sm2};
    font-weight: ${theme.v2.font.weights.medium};
  `}
`;

export const CountryWrapper = styled.span`
  ${({ theme }) => css`
    align-items: center;
    display: flex;
    justify-content: flex-start;
    max-width: 100%;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      max-width: unset;
      width: unset;
    }
  `}
`;

export const AmountWrapper = styled.span`
  ${({ theme }) => css`
    align-items: center;
    display: flex;
    justify-content: flex-start;
    max-width: 162px;
    position: relative;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      max-width: unset;
      width: unset;
    }
  `}
`;

export const PaginationWrapper = styled.div`
  ${({ theme }) => css`
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin: 24px 0px 0px;
    position: relative;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      flex-direction: column;
      gap: 16px;
      justify-content: center;
      margin: 32px 0px 0px;
    }
  `}
`;

export const PerPagelLabel = styled.label`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowMedium};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.text};
  `}
`;

export const SelectWrapper = styled.div`
  ${({ theme }) => css`
    align-items: center;
    display: flex;
    gap: 8px;
    justify-content: center;
    position: absolute;
    right: 0px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      display: block;
      position: unset;
      width: 100%;
    }
  `}
`;

export const VisitsEmptyWrapper = styled(Wrapper)`
  padding: 32px 0;
  position: relative;
  width: 100%;

  ${({ theme }) => css`
    @media(min-width: ${theme.v2.breakpoints.lg}) {
      padding: 98px 0;
    }
  `}
`;

export const VisitsEmpty = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 10px;
`;

export const TitleEmpty = styled.h2`
  ${({ theme }) => css`
    align-items: center;
    color:${theme.v2.colors.brand.primaryExtraDark};
    display: flex;
    flex-direction: row;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.bold};
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 0;

    @media(min-width: ${theme.v2.breakpoints.lg}) {
      font-size: ${theme.v2.font.sizes.sm2};
    }
  `}
`;

export const DescriptionEmpty = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.text};
    white-space: break-spaces;
    margin: 0;
    text-align: center;

    @media(min-width: ${theme.v2.breakpoints.lg}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }
  `}
`;
